/**
 * Common reusable components.
 */

// Empty State
export const EmptyState = ({ icon: Icon, title, description }) => (
  <div className="flex flex-col items-center justify-center py-16 px-6 text-center animate-fadeIn">
    <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
      <Icon size={36} className="text-gray-400" />
    </div>
    <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
    <p className="text-sm text-gray-500 max-w-xs">{description}</p>
  </div>
);

// Stats Counter
export const StatsCounter = ({ stats, loading }) => (
  <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 mb-4 animate-fadeIn">
    <div className="grid grid-cols-4 gap-3">
      {[
        { label: "Pozivi", value: stats.calls, color: "blue", loading },
        { label: "Sastanci", value: stats.meetings, color: "green", loading },
        { label: "Ponude", value: stats.offers, color: "amber", loading },
        { label: "Akviz.", value: stats.acquisitions, color: "rose", loading },
      ].map(({ label, value, color }) => (
        <div key={label} className="text-center">
          <div className={`text-xl font-bold text-${color}-600 ${loading ? 'animate-pulse' : ''}`}>
            {loading ? "-" : value}
          </div>
          <div className="text-[10px] text-gray-500 uppercase tracking-wide">{label}</div>
        </div>
      ))}
    </div>
  </div>
);

// Status Badge
export const StatusBadge = ({ status }) => {
  const statusConfig = {
    OVERDUE: { bg: "bg-red-100", text: "text-red-700", label: "Kasni" },
    TODAY: { bg: "bg-amber-100", text: "text-amber-700", label: "Danas" },
    SCHEDULED: { bg: "bg-blue-100", text: "text-blue-700", label: "Zakazano" },
    NEW: { bg: "bg-emerald-100", text: "text-emerald-700", label: "Novi" },
    NO_NEXT: { bg: "bg-gray-100", text: "text-gray-600", label: "Bez datuma" },
    CLOSED: { bg: "bg-gray-100", text: "text-gray-500", label: "Zatvoren" },
    DO_NOT_CONTACT: { bg: "bg-red-50", text: "text-red-600", label: "Ne kontaktirati" }
  };
  
  const config = statusConfig[status] || statusConfig.NO_NEXT;
  
  return (
    <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${config.bg} ${config.text}`}>
      {config.label}
    </span>
  );
};

// Protected Route Component
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="mobile-container flex items-center justify-center">
        <div className="text-gray-500">Učitavanje...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};
